<template>
  <div class="pa-4">
    <div v-html="scenario.title"></div>
    <div
      class="mt-4 caption hyp-scenario-overview"
      v-html="scenario.overview"
    ></div>
  </div>
</template>

<script>
export default {
  name: "RisksScenariosOverview",
  components: {},
  props: {
    scenario: {
      type: Object,
      required: true,
    },
    titleMinHeight: {
      type: String,
      default: "auto",
    },
  },
};
</script>

<style scoped>
.v-application .font-weight-bold {
  font-weight: 700 !important;
}
</style>
